document.addEventListener("DOMContentLoaded", function () {
  document.querySelector('[newsletter-submit]').addEventListener('click', function (e) {
    e.preventDefault();
    const emailInput = document.querySelector('[newsletter-email]');
    const email = emailInput.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email === '') {
      emailInput.focus();
      alert('이메일을 입력하세요.');
      return false;
    }
    if (!emailRegex.test(email)) {
      emailInput.focus();
      alert('이메일을 정확하게 입력하세요.');
      return false;
    }
    document.querySelector('[stibee-input]').value = email;
    document.querySelector('[stibee-submit]').style.display = 'block';
    document.querySelector('[complete-button]').style.display = 'none';
    const resultElement = document.querySelector('[stibee-result]');
    resultElement.innerHTML = '';
    resultElement.classList.remove('fail', 'success');
    document.querySelector('[stibee-first-image]').style.display = 'block';
    document.querySelector('[success-image]').style.display = 'none';
    Array.from(document.querySelector('[stibee-form]').children).forEach(child => child.style.display = 'block');
    document.querySelector('[stibee-container]').classList.add('on');
    document.querySelector('[stibee-overlay]').classList.add('on');
  });

  document.querySelectorAll('[scrolling-child]').forEach(slide => {
    slide.addEventListener('click', function () {
      document.querySelector('[stibee-submit]').style.display = 'block';
      document.querySelector('[complete-button]').style.display = 'none';
      const resultElement = document.querySelector('[stibee-result]');
      resultElement.innerHTML = '';
      resultElement.classList.remove('fail', 'success');
      document.querySelector('[stibee-first-image]').style.display = 'block';
      document.querySelector('[success-image]').style.display = 'none';
      Array.from(document.querySelector('[stibee-form]').children).forEach(child => child.style.display = 'block');
      document.querySelector('[stibee-container]').classList.add('on');
      document.querySelector('[stibee-overlay]').classList.add('on');
    });
  });

  document.querySelectorAll('[stibee-overlay], [popup-close], [complete-button]').forEach(element => {
    element.addEventListener('click', function () {
      document.querySelector('[stibee-container]').classList.remove('on');
      document.querySelector('[stibee-overlay]').classList.remove('on');
      document.querySelector('[stibee-input]').value = '';
      document.querySelector('[stibee-checkbox]').checked = false;
      document.querySelector('[stibee-submit]').classList.remove('disabled');
    });
  });

  window.STBSUBFORM = window.STBSUBFORM || {};
  STBSUBFORM.showResult = function (response, status) {
    let resMsg;
    const resultDom = document.querySelector('[stibee-result]');
    if (status === 'fail') {
      resMsg = '<p>' + response.split('ERROR_MSG:')[1].split('-->')[0] + '</p>';
    } else {
      resMsg = response.split('<div class="msg">')[1].split('</div>')[0];
    }
    if (resMsg.includes('이미 구독 중인 이메일')) {
      STBSUBFORM.showError('stb_email', response.split('ERROR_MSG:')[1].split('-->')[0]);
    } else if (resMsg.includes('이미 구독 중인 전화번호')) {
      STBSUBFORM.showError('stb_$phone', response.split('ERROR_MSG:')[1].split('-->')[0]);
    } else {
      resultDom.style.display = 'block';
      resultDom.innerHTML = resMsg;
      if (status === 'success') {
        resultDom.classList.add('success');
        document.querySelector('[stibee-submit]').style.display = 'none';
        document.querySelector('[complete-button]').style.display = 'block';
        document.querySelector('[stibee-first-image]').style.display = 'none';
        document.querySelector('[success-image]').style.display = 'block';
        Array.from(document.querySelector('[stibee-form]').children).forEach(child => {
          if (!child.classList.contains('stb_form_set_submit')) {
            child.style.display = 'none';
          }
        });
      } else if (status === 'fail') {
        resultDom.classList.add('fail');
        setTimeout(function () {
            STBSUBFORM.toggleButtonActivation(true);
        }, 2000);
      }
    }
  };
});
